import { connectUsersWithLessons } from "api/services/user-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { useCallback } from "react";

export const useConnectUsersWithLessons = () => {
    const { callAPI, loading } = useWorkspaceApiCall(connectUsersWithLessons, 'connectUsersWithLessons.success', 'connectUsersWithLessons.error');
    
    const connectUsersWithLessonsMethod = useCallback(async (lessonIds: string[], userIds: string[]) => {
        const resp = await callAPI({ lessonIds, userIds });
        return resp;
    }, [callAPI]);

    return { connectUsersWithLessons: connectUsersWithLessonsMethod, connectingUsersWithLessons: loading }
}